import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { GlobalOpportunityDetailsSheetContainer } from '@/features/opportunities/components/OpportunityDetailsSheet/GlobalOpportunityDetailsSheetContainer'
import { VanishedDialogContainer } from '@/features/opportunities/VanishedDialog/VanishedDialogContainer'

/**
 * Inner component which requests the actual loading of the module.
 */
export default observer(function Inner() {
  const { opportunities } = useFeatures((r) => ({
    opportunities: r.opportunities.internal(),
  }))
  const opportunitiesVm =
    opportunities.opportunitiesRootViewModel.opportunitiesVm

  return (
    <>
      <GlobalOpportunityDetailsSheetContainer vm={opportunitiesVm} />
      <VanishedDialogContainer
        vm={opportunitiesVm.detailsVm.vanishedDialogVm}
      />
    </>
  )
})
